module.exports = __webpack_public_path__ + "static/media/user-phone-motorola.a46c5fc1.svg";